export default {
	project_name: 'CRM Play',
	see_the_full_ranking: 'See more',
	company_agency: 'Store',
}
